import { FC } from "react";
import { useLocation } from "react-router-dom";
import PopupDeleteAccountComponent from "../../components/popup/setting/delete-account";

const PopupDeleteAccount: FC = () => {
  const { state } = useLocation();

  return <PopupDeleteAccountComponent />;
};

export default PopupDeleteAccount;
